import { Uint8ToBlob } from "@pdfking/tfunc"

export default (bytes: Uint8Array, mimetype: string): string =>
  URL.createObjectURL(Uint8ToBlob(bytes, mimetype))
